import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";
import { IAddonEditCTRFormData } from "../IApisInterface";

export const addonCTRPurchaseApi = async (business_id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.getCTRPurchase, {
    business_id,
  });
  return response;
};

export const addonMapCheckInsPurchaseApi = async (business_id: string) => {
  const response = await AxiosInstance.post(
    apiRoutes?.addonMapCheckInPurchase,
    { business_id },
  );
  return response;
};

export const addonConfirmCTRPurchaseApi = async (id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.confirmCTRPurchase, {
    id,
  });
  return response;
};

export const addonGetCTRFormApi = async (business_id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.addonGetCTRForm, {
    business_id,
  });
  return response;
};

export const addonEditCTRFormApi = async (payload: IAddonEditCTRFormData) => {
  const response = await AxiosInstance.post(apiRoutes?.addonCTRForm, payload);
  return response;
};
